import { render, staticRenderFns } from "./PreviewAndJsonEditor.vue?vue&type=template&id=428aecf5"
import script from "./PreviewAndJsonEditor.vue?vue&type=script&lang=js"
export * from "./PreviewAndJsonEditor.vue?vue&type=script&lang=js"
import style0 from "./PreviewAndJsonEditor.vue?vue&type=style&index=0&id=428aecf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports